import { DesigntimeComponent } from './DesigntimeComponent.js'
import { LiquidString } from '../common/LiquidString.js'
import * as $ from 'jquery';

class InfoReplace extends DesigntimeComponent {
    static staticName = "Info (Replace)";
    static staticId = "infoReplace";

    constructor(identifyer) {
        super(identifyer, 2);

        this.values = {
            header: new LiquidString("You spend {{parameter1}} £/month with Mr Green. That’s less than the average player in the United Kingdom, who spends {{parameter2}} £/month*.", `${this.id}_header`),
            subtext: new LiquidString("*Data is based on Swedish research, the median of active players’ stake per month <a href='x'>Click</a> ", `${this.id}_subtext`),
            buttontext: { value: "Next" },
            imageurl: { value: "placeholder.png", dontTranslate: true },
            imageclass: { value: "sid-image-circle", dontTranslate: true }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));

        var $view = $("<div></div>");
        var $textbox = $("<div class='sid-question-text'></div>");
        $textbox.append(this.values.header.getTag("h3"));
        $textbox.append(this.values.subtext.getTag("p"));
        $view.append($textbox);

        var $imagebox = $("<div class='sid-question-image'></div>");
        if (this.values.imageurl.value) {
            $imagebox.append($("<img class='" + this.values.imageclass.value + "' src='" + context.getContentUrl() + this.values.imageurl.value + "'>"));
            $view.append($imagebox);
        }

        return $view;
    }

    importModel(model) {
        for (var param in model.params) {
            for (var i in this.values) {
                if (this.values[i] instanceof LiquidString)
                    this.values[i].replace(`{{${param}}}`, `{{${model.params[param].key}}}`);
            }
        }
        delete model.params.parameter1;
        delete model.params.parameter2;
        delete model.params.parameter3;

        super.importModel(model);
    }
}

export { InfoReplace }
